// Hall outlines on venue-layout.svg (India Expo Mart, Greater Noida) - the
// file in itmeems_node document/Svgtogeojson/exhibition_<id>/, see VenueView -
// in that file's own user space (viewBox 0 0 1191 842).
//
// Fixed venue geometry, kept in code on purpose: the halls do not move.
// Everything else on the Layout View comes from the procedure's data.
//
// The file is a PDF export (8.8 MB as of 2026-10-02), too heavy to inject into the DOM and
// trace at runtime the way the hall layout SVG is, so these boxes are read
// off it once. REPLACING THE VENUE FILE MEANS RE-DERIVING THEM - the overlay
// is drawn in the file's own units, so a file with a different viewBox puts
// every hall off the picture (that happened on 2026-09-28: the 3370 x 2384
// drawing was replaced by this 1191 x 842 one).
//
// How they were derived (2026-09-29): the new file is the same plan at another
// scale. Each hall's label ("HALL- 1") was read from the file's <text>, the
// previous boxes were fitted to those labels (x' = 0.3455x + 1.6,
// y' = 0.3321y + 26.2; hall centres within ~2 units of their labels, Halls
// 14-17 further only because their labels sit off-centre) and mapped across.
//
// Re-derived 2026-10-02 for the 8.8 MB re-export (same 1191 x 842 viewBox,
// the plan drawn larger): 47 text labels common to both files fit
// x' = 1.19131x - 13.867, y' = 1.19131y + 3.675 to within 0.2 units, and every
// box was mapped across. Halls 14-17 were then traced off the drawing's own
// walls: 17 is the strip under the top outline over Hall 15 (its corner cut by
// the outline's step), 15 and 14 stack below it, and 16 runs from the stepped
// outline down to the line over Halls 9-12, beside 17, 15 and 14.
// The same file must be on every server - UAT and prod - or the halls drift.
//
//   - Halls 1, 3, 5, 7 are the ground floor of the mart building;
//     2, 4, 6, 8 its upper floor (Sapphire, Emerald, Amber, Amber).
//   - Halls 14, 15 and 17 are stacked in one block (17 on top), with 16 beside the whole block.
//   - SEMINAR HALL sits inside Sapphire Hall-2 and is not a tracked hall.
//
// hallName matches the database's HallName, which is how status joins.
// venueZone mirrors #VenueZoneHall in sp_get_hallviewauditTrackerLayout
// (1 = mart building, Halls 1-8; 2 = the west block, Halls 9-17), so a hall
// with no rows yet still belongs to its zone.
export const VENUE_VIEWBOX = { width: 1191, height: 842 };

export const VENUE_HALLS = [
  { hallName: "Hall 1", label: "Hall 1", venueZone: "1", x: 692.3, y: 378.3, w: 65.4, h: 55.8 },
  { hallName: "Hall 2", label: "Hall 2 (Sapphire)", venueZone: "1", x: 695.6, y: 338, w: 62.5, h: 39.9 },
  { hallName: "Hall 3", label: "Hall 3", venueZone: "1", x: 626.5, y: 378.3, w: 65.9, h: 56.2 },
  { hallName: "Hall 4", label: "Hall 4 (Emerald)", venueZone: "1", x: 633, y: 338, w: 62.5, h: 40.4 },
  { hallName: "Hall 5", label: "Hall 5", venueZone: "1", x: 559.4, y: 378.3, w: 67.1, h: 56.2 },
  { hallName: "Hall 6", label: "Hall 6 (Amber)", venueZone: "1", x: 563.1, y: 338, w: 69.9, h: 40.4 },
  { hallName: "Hall 7", label: "Hall 7", venueZone: "1", x: 492.7, y: 378.3, w: 66.7, h: 56.2 },
  { hallName: "Hall 8", label: "Hall 8 (Amber)", venueZone: "1", x: 492.7, y: 338, w: 70.4, h: 40.4 },
  { hallName: "Hall 9", label: "Hall 9", venueZone: "2", x: 356.4, y: 433.3, w: 68.7, h: 166.9 },
  { hallName: "Hall 10", label: "Hall 10", venueZone: "2", x: 288.1, y: 433.3, w: 68.4, h: 166.9 },
  { hallName: "Hall 11", label: "Hall 11", venueZone: "2", x: 219.8, y: 433.3, w: 68.4, h: 166.9 },
  { hallName: "Hall 12", label: "Hall 12", venueZone: "2", x: 150.2, y: 433.3, w: 69.6, h: 166.9 },
  { hallName: "Hall 14", label: "Hall 14", venueZone: "2", x: 156.3, y: 353.7, w: 189.5, h: 63.1 },
  { hallName: "Hall 15", label: "Hall 15", venueZone: "2", x: 156.3, y: 291.2, w: 189.5, h: 62.5 },
  { hallName: "Hall 16", label: "Hall 16", venueZone: "2", x: 345.8, y: 265.2, w: 79.5, h: 163.1 },
  // The strip under the top outline, over Hall 15; its top-right corner is cut
  // by the outline's step. x/y/w/h is its bounding box; points is what is drawn.
  {
    hallName: "Hall 17", label: "Hall 17", venueZone: "2", x: 156.3, y: 250.5, w: 189.5, h: 40.7,
    points: [[156.3, 250.5], [317, 250.5], [317, 265.2], [345.8, 265.2], [345.8, 291.2], [156.3, 291.2]],
  },
];

// A hall as axis-aligned rectangles: its box, or its polygon cut into the
// cells of its own corner coordinates.
const hallRects = (hall) => {
  if (!hall.points) return [{ x0: hall.x, y0: hall.y, x1: hall.x + hall.w, y1: hall.y + hall.h }];
  const inside = (px, py) => {
    let hit = false;
    const pts = hall.points;
    for (let i = 0, j = pts.length - 1; i < pts.length; j = i++) {
      const [xi, yi] = pts[i];
      const [xj, yj] = pts[j];
      if ((yi > py) !== (yj > py) && px < ((xj - xi) * (py - yi)) / (yj - yi) + xi) hit = !hit;
    }
    return hit;
  };
  const xs = [...new Set(hall.points.map((p) => p[0]))].sort((a, b) => a - b);
  const ys = [...new Set(hall.points.map((p) => p[1]))].sort((a, b) => a - b);
  const rects = [];
  for (let i = 0; i < xs.length - 1; i++) {
    for (let j = 0; j < ys.length - 1; j++) {
      if (inside((xs[i] + xs[i + 1]) / 2, (ys[j] + ys[j + 1]) / 2)) {
        rects.push({ x0: xs[i], y0: ys[j], x1: xs[i + 1], y1: ys[j + 1] });
      }
    }
  }
  return rects;
};

// The shape of a venue zone: its halls grown by pad, with the corridors
// between them filled in (every row and column is filled between its first and
// last covered cell), so the zone reads as one block yet still follows steps
// in the outline - the corner cut off Hall 17 and the strip above Hall 16 stay
// outside. Returns SVG path data: fill (the area) and outline (its edge).
export const venueZoneShape = (halls, pad) => {
  const rects = halls.flatMap(hallRects).map((r) => ({
    x0: r.x0 - pad, y0: r.y0 - pad, x1: r.x1 + pad, y1: r.y1 + pad,
  }));
  if (rects.length === 0) return null;
  const xs = [...new Set(rects.flatMap((r) => [r.x0, r.x1]))].sort((a, b) => a - b);
  const ys = [...new Set(rects.flatMap((r) => [r.y0, r.y1]))].sort((a, b) => a - b);
  const nx = xs.length - 1;
  const ny = ys.length - 1;
  const on = Array.from({ length: nx }, (_, i) =>
    Array.from({ length: ny }, (_, j) => {
      const cx = (xs[i] + xs[i + 1]) / 2;
      const cy = (ys[j] + ys[j + 1]) / 2;
      return rects.some((r) => cx > r.x0 && cx < r.x1 && cy > r.y0 && cy < r.y1);
    })
  );
  // Fill rows, then columns, until nothing changes.
  for (let changed = true; changed;) {
    changed = false;
    for (let j = 0; j < ny; j++) {
      let first = -1;
      let last = -1;
      for (let i = 0; i < nx; i++) if (on[i][j]) { if (first < 0) first = i; last = i; }
      for (let i = first + 1; i < last; i++) if (!on[i][j]) { on[i][j] = true; changed = true; }
    }
    for (let i = 0; i < nx; i++) {
      const first = on[i].indexOf(true);
      const last = on[i].lastIndexOf(true);
      for (let j = first + 1; j < last; j++) if (!on[i][j]) { on[i][j] = true; changed = true; }
    }
  }
  const covered = (i, j) => i >= 0 && j >= 0 && i < nx && j < ny && on[i][j];
  let fill = "";
  let outline = "";
  for (let i = 0; i < nx; i++) {
    for (let j = 0; j < ny; j++) {
      if (!on[i][j]) continue;
      const [x0, x1, y0, y1] = [xs[i], xs[i + 1], ys[j], ys[j + 1]];
      fill += `M${x0} ${y0}H${x1}V${y1}H${x0}Z`;
      if (!covered(i, j - 1)) outline += `M${x0} ${y0}H${x1}`;
      if (!covered(i, j + 1)) outline += `M${x0} ${y1}H${x1}`;
      if (!covered(i - 1, j)) outline += `M${x0} ${y0}V${y1}`;
      if (!covered(i + 1, j)) outline += `M${x1} ${y0}V${y1}`;
    }
  }
  return { fill, outline };
};
